export default __webpack_public_path__ + "static/media/ChartLineSolid.70e324dd.svg";